<div class="cx-review-cart-item" *ngIf="sortedDeliveries; else loading">
  <div *ngFor="let delivery of sortedDeliveries" class="eb-order-details__delivery">
    <div class="eb-order-details__delivery-header">
      <h3>
        {{ 'orderDetails.' + getDeliveryTitle(delivery) | cxTranslate }}
        {{ delivery?.goodsIssueDate ? (getFormattedDate(delivery?.goodsIssueDate) | async) : '' }}
      </h3>
      <span class="eb-order-details__delivery-tracking"
            *ngIf="delivery.trackNo && delivery.trackUrl">
        <h5 class="eb-order-details__delivery-tracking-label">
          {{ 'orderDetails.trackingId' | cxTranslate }}
        </h5>
        <a
          *ngIf="delivery.trackUrl"
          [href]="delivery.trackUrl"
          target="_blank"
          class="eb-order-details__delivery-tracking-no"
          >{{ delivery.trackNo }} <em class="fas fa-external-link"></em>
        </a>
        <span *ngIf="!delivery.trackUrl">{{ delivery.trackNo }}</span>
      </span>
    </div>
    <eb-cart-item-list
      [items]="delivery?.items"
      [readonly]="true"
      [controlled]="false"
      [showPriceValue]="false"
      [showAvailability]="false"
      [loadAvailabilities]="false"
      [loadPrices]="false"
      [showAddToCart]="false"
    ></eb-cart-item-list>
  </div>
</div>
<ng-template #loading>
  <eb-spinner class="my-3 d-block"></eb-spinner>
</ng-template>
